// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"BgVideoCloud_bgVideoWrapper__7WKuB"};